module.exports = __webpack_public_path__ + "img/flower4.4aebe118.png";